import React from 'react';
import {
  Identifier,
  Datagrid,
  DateField,
  DatagridProps,
  TextField,
  BooleanField,
} from 'react-admin';
import { makeStyles } from '@material-ui/core/styles';

const useListStyles = makeStyles({
  headerRow: {
    borderLeftColor: 'transparent',
    borderLeftWidth: 5,
    borderLeftStyle: 'solid',
  },
  headerCell: {
    padding: '6px 8px 6px 8px',
  },
  rowCell: {
    padding: '6px 8px 6px 8px',
  },
  comment: {
    maxWidth: '18em',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
});

export const MessageField = ({ record = {} }: any) => {
  return (
    <div
      style={{
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        width: '500px',
        whiteSpace: 'nowrap',
      }}
    >
      {record.message}
    </div>
  );
};

export interface ChefListDesktopProps extends DatagridProps {
  selectedRow?: Identifier;
}

const ChefListDesktop = ({ selectedRow, ...props }: ChefListDesktopProps) => {
  const classes = useListStyles();
  return (
    <Datagrid
      rowClick="edit"
      classes={{
        headerRow: classes.headerRow,
        headerCell: classes.headerCell,
        rowCell: classes.rowCell,
      }}
      optimized
      {...props}
    >
      <TextField label="Ordre" source="order" />
      <TextField label="Prénom" source="firstname" />
      <TextField label="Nom" source="lastname" />
      <TextField label="Description" source="description" />
      <BooleanField label="Actif" source="is_active" />
      <DateField label="Créé le" source="created_at" />
    </Datagrid>
  );
};

export default ChefListDesktop;
